import React from "react";
import { Alert } from "antd";
import { InfoCircleOutlined, WarningOutlined, CheckCircleOutlined } from "@ant-design/icons";

interface SetupTipsProps {
    tips: string[];
    title?: string;
    variant?: "info" | "warning" | "success";
}

export const SetupTips: React.FC<SetupTipsProps> = ({ tips, title = "Setup Instructions", variant = "info" }) => {
    const getIcon = () => {
        switch (variant) {
            case "warning":
                return <WarningOutlined />;
            case "success":
                return <CheckCircleOutlined />;
            case "info":
            default:
                return <InfoCircleOutlined />;
        }
    };

    if (tips.length === 0) return null;

    const description = (
        <ol className="list-decimal list-inside space-y-1 mt-2">
            {tips.map((tip, index) => (
                <li key={index} className="leading-relaxed">
                    {tip}
                </li>
            ))}
        </ol>
    );

    return (
        <Alert
            message={title}
            description={description}
            type={variant}
            icon={getIcon()}
            showIcon
            className="rounded-lg"
        />
    );
};
